import React from 'react';
import { connect } from 'react-redux';
import { reduxForm, reset } from 'redux-form';

import DashBoard from '../../components/Dashboard';
import PostForm from '../../components/Posts/PostForm';
import { addPost } from '../../redux/modules/post/action';
import { getList } from '../../redux/modules/user/action';

class AddPost extends React.Component {
  componentDidMount () {
    const { dispatch } = this.props;
    dispatch(getList());
  }

  addPost = (props) => {
    const { dispatch } = this.props;
    dispatch(addPost(props))
      .then(() => dispatch(reset('addPost')))
      .catch((e) => console.log(e));
  }

  render() {
    const { handleSubmit, userList, message } = this.props;
    return (
      <DashBoard>
        <PostForm
          handleSubmit={handleSubmit}
          addPost={this.addPost}
          userList={userList}
          message={message}
          formName='Add'
        />
      </DashBoard>
    )
  }
}
const mapStateToProps = (state) => {
  return {
    userList: state.user.list,
    message: state.post.message,
    initialValues: {
      type: '0'
    }
  }
}


export default connect(mapStateToProps)(reduxForm({
  form: "addPost",
  enableReinitialize: true
})(AddPost));